export class IntrospectRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "token",
            "baseName": "token",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IntrospectRequest.attributeTypeMap;
    }
    constructor() {
    }
}
